import React, { useState } from 'react';
import { Grid, TextField, IconButton, CircularProgress, alpha, Box } from '@mui/material';
import { Mic as MicIcon, Send as SendIcon } from '@mui/icons-material';
import { ReactMic } from 'react-mic';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import { uploadAudioToAPI } from '../../api/chat';

const MessageInput = ({ newMessage, setNewMessage, sendMessage, isLoading }) => {
  const [recording, setRecording] = useState(false);
  const [loadingAudio, setLoadingAudio] = useState(false);

  const handleMicClick = () => setRecording(prev => !prev);

  const onStop = async (recorded) => {
    setLoadingAudio(true);
    const formData = new FormData();
    formData.append('audio', recorded.blob, 'audio.webm');

    try {
      const translated = await uploadAudioToAPI(formData);
      if (translated) setNewMessage((prev) => (prev + ' ' + translated).trim());
    } catch (err) {
      console.error('Audio upload failed', err);
    } finally {
      setLoadingAudio(false);
    }
  };

  return (
    <Grid
        container
        alignItems="center"
        sx={{
            px: 2,
            py: 1,
            backgroundColor: "fff",
            backdropFilter: 'blur(10px)',
            position: 'fixed',
            bottom: "60px"
        }}
        >
        <Grid item xs={11}>
            <Box display="flex" alignItems="center" width="100%">
            <TextField
                fullWidth
                variant="outlined"
                placeholder="Type your message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && !isLoading && sendMessage()}
                sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: alpha('#ffffff', 0.8),
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    pr: 1
                }
                }}
            />
              <IconButton size="small" onClick={handleMicClick} sx={{ ml: 1 }}>
                {loadingAudio ? (
                  <CircularProgress size={20} />
                ) : recording ? (
                  <PauseCircleFilledIcon fontSize="small" color="primary" />
                ) : (
                  <MicIcon fontSize="small" />
                )}
              </IconButton>
            </Box>

            {/* Hidden mic - no waveform, no layout issue */}
            <ReactMic
                visualSetting="undefined"
                record={recording}
                onStop={onStop}
                mimeType="audio/webm"
                strokeColor="#000000"
                backgroundColor="#ffffff"
                style={{ display: 'none', position: 'absolute', width: 0, height: 0 }}
            />
        </Grid>

        <Grid item xs={1}>
            <IconButton
            color="primary"
            onClick={sendMessage}
            disabled={isLoading || !(newMessage || '').trim()}
            sx={{
                backgroundColor: alpha('#2196f3', 0.1),
                px: "auto",
                '&:hover': { backgroundColor: alpha('#2196f3', 0.2) }
            }}
            >
            <SendIcon fontSize="small" />
            </IconButton>
        </Grid>
    </Grid>
  );
};

export default MessageInput;